import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    FormGroup,
} from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CommonHeader from "components/Headers/CommonHeader.js";
import { getTermsAndConditions, saveTermsAndConditions } from "api/ApiServices";
import Swal from "sweetalert2";

const TermsConditions = () => {
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTermsAndConditions();
    }, []);

    const fetchTermsAndConditions = async () => {
        console.log("fetchTermsAndConditions");
        try {
            setLoading(true);
            const data = await getTermsAndConditions();
            console.log(data);
            if (data.status && data.payload && data.payload.termsAndConditions) {
                setContent(data.payload.termsAndConditions.tc_content || "");
            }
        } catch (error) {
            console.error("Error fetching terms and conditions:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            if (!content.trim()) {
                Swal.fire("Error", "Terms and Conditions content cannot be empty", "error");
                return;
            }

            setLoading(true);
            const data = await saveTermsAndConditions({ tc_content: content });
            if (data.status) {
                Swal.fire("Success", "Terms and Conditions updated successfully", "success");
            } else {
                Swal.fire("Error", data.message || "Something went wrong", "error");
            }
        } catch (error) {
            console.error("Error saving terms and conditions:", error);
            Swal.fire("Error", "Failed to save terms and conditions", "error");
        } finally {
            setLoading(false);
        }
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"],
        ],
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "image",
    ];

    return (
        <>
            <CommonHeader />
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="bg-transparent py-4">
                                <Row className="align-items-center">
                                    <Col>
                                        <h3 className="mb-0 text-dark font-weight-700">
                                            <i className="ni ni-paper-diploma text-warning mr-2" /> Manage Terms and Conditions
                                        </h3>
                                    </Col>
                                    <Col className="text-right">
                                        <Button
                                            color="primary"
                                            onClick={handleSave}
                                            disabled={loading}
                                            size="md"
                                            className="px-4"
                                            style={{ borderRadius: "8px" }}
                                        >
                                            {loading ? "Saving..." : "Save Changes"}
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="p-4">
                                <FormGroup>
                                    <div style={{ height: "500px", marginBottom: "60px" }}>
                                        <ReactQuill
                                            theme="snow"
                                            value={content}
                                            onChange={setContent}
                                            modules={modules}
                                            formats={formats}
                                            style={{ height: "100%", borderRadius: "8px" }}
                                            placeholder="Write terms and conditions content here..."
                                        />
                                    </div>
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default TermsConditions;
